import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import dayjs from 'dayjs';
import { useSnackbar } from 'notistack';
import React, { useState } from "react";
import { mdiCarOff, mdiCar, mdiCarDoor, mdiCarDoorLock, mdiMapMarkerDistance, mdiCloseCircle, mdiDominoMask, mdiCrosshairsGps } from '@mdi/js';
import Icon from '@mdi/react';
import { useActions, useValues } from 'kea';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { InputLabel, Select, MenuItem, Switch } from '@material-ui/core';

import ImmobiliseDialog from 'src/views/Vehicle/ImmobiliseDialog';
import vehiclelogic from 'src/store/vehicle';
import checkRole from 'src/utils/checkRole';
import profilelogic from 'src/store/profile';
import alertlogic from 'src/store/alert';


const useStyles = makeStyles({
	root: {
		minWidth: "100%"
	},
	table: {
		minWidth: "500px",
		maxHeight: 400
	},
	limitFont: {
		fontSize: 13
	}
});

const stolenAlert = '6375d245f0aad89ba8ee927e';  // live
// const stolenAlert = '607ccb5d6b81bc88a45f2c21';

export default function Actions({ vehicle }) {
	const classes = useStyles();

	const { profile } = useValues(profilelogic);

	const { immobilise, doorlock, requestTripCounter, resetTripCounter, getRecord } = useActions(vehiclelogic);
	const { tripCounter } = useValues(vehiclelogic);

	const { alerts } = useValues(alertlogic);
	const { update, add_one, remove_one } = useActions(alertlogic);


	const handleMobilise = () => {
		const confirmed = window.confirm('Do you want to MOBILISE the vehicle?');
		if (confirmed) {
			immobilise({ _id: vehicle._id, state: false });
		}
	}

	const handleImmobilise = () => {
		const confirmed = window.confirm('Do you want to IM-MOBILISE the vehicle?');
		if (confirmed) {
			immobilise({ _id: vehicle._id, state: true });
		}
	}

	const handleDoorUnlock = () => {
		const confirmed = window.confirm('Do you want to UN-LOCK the vehicle?');
		if (confirmed) {
			doorlock({ _id: vehicle._id, state: false });
		}
	}

	const handleDoorLock = () => {
		const confirmed = window.confirm('Do you want to LOCK the vehicle?');
		if (confirmed) {
			doorlock({ _id: vehicle._id, state: true });
		}
	}

	const handleRequestTripCounter = () => {
		requestTripCounter({ _id: vehicle._id })
	}

	const handleResetTripCounter = () => {
		const confirmed = window.confirm('Do you want to Reset the trip?');
		if (confirmed) {
			resetTripCounter({ _id: vehicle._id })
		}
	}

	const handleToggleStolen = () => {
		const stolenalert = alerts.find(alert => alert._id === stolenAlert)
		if (!stolenalert) return;
		const stolen = stolenalert.vehicles.find(alertvehicle => alertvehicle.vehicle._id === vehicle._id);
		if (stolen) {
			let updated_alert = stolenalert;
			updated_alert.vehicles = updated_alert.vehicles.filter(alertvehicle => alertvehicle.vehicle._id !== vehicle._id);
			// console.log(updated_alert)
			update(updated_alert)
		} else {
			let updated_alert = stolenalert;
			updated_alert.vehicles.push({
				schedule: [],
				vehicle: vehicle._id,
				enabled: true
			});
			// console.log(updated_alert)
			update(updated_alert)
		}
	}

	const handleAddStolen = () => {
		// console.log(stolenAlert, vehicle._id)
		add_one(stolenAlert, vehicle._id)
	}

	const handleRemoveStolen = () => {
		// console.log(stolenAlert, vehicle._id)
		remove_one(stolenAlert, vehicle._id)
	}

	const handleGetRecordCommand = () => {
		// console.log(stolenAlert, vehicle._id)
		getRecord({ _id: vehicle._id })
	}

	return (
		<div className={classes.root} >
			<TableContainer style={{ maxHeight: '400px' }}>
				<Table stickyHeader size="small" aria-label="a dense table" className={classes.table}>
					<TableHead>
						{checkRole(profile, ['VehicleImmobilise']) && ['FMC130', 'FMU125', 'TZ-AVL05(3G)', 'Dart34G'].includes(vehicle.tracker.model) &&
							<TableRow key={"1"}>
								<TableCell align="right">
									<b>Currently:</b>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
									{vehicle?.tracker?.status[0]?.io?.immobilised ? 'Immobilised' : 'Mobilised'}
								</TableCell>
								<TableCell align="right" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiCar} size={1} />}
										onClick={handleMobilise}
									>
										Mobilise
									</Button>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiCarOff} size={1} />}
										onClick={handleImmobilise}
									>
										Immobilise
									</Button>
								</TableCell>
							</TableRow>
						}
						{checkRole(profile, ['VehicleDoorLock']) && ['FMC130', 'FMU125', 'TZ-AVL05(3G)'].includes(vehicle.tracker.model) &&
							<TableRow key={"2"}>
								<TableCell align="right">
									<b>Door Lock:</b>
								</TableCell>
								<TableCell align="right">
								</TableCell>
								<TableCell align="right" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiCarDoor} size={1} />}
										onClick={handleDoorUnlock}
									>
										Unlock
									</Button>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiCarDoorLock} size={1} />}
										onClick={handleDoorLock}
									>
										Lock
									</Button>
								</TableCell>
							</TableRow>
						}
						{checkRole(profile, ['VehicleTripCounter'], false) &&
							<TableRow key={"3"}>
								<TableCell align="right">
									<b>Trip Counter:</b>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
									{tripCounter?.vehicle === vehicle._id ? tripCounter.mileage + ' ' + tripCounter.units : '...'}
								</TableCell>
								<TableCell align="right" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiMapMarkerDistance} size={1} />}
										onClick={handleRequestTripCounter}
									>
										Request
									</Button>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiCloseCircle} size={1} />}
										onClick={handleResetTripCounter}
									>
										Reset
									</Button>
								</TableCell>
							</TableRow>
						}
						{checkRole(profile, ['StolenAlertShortcut'], false) &&
							<TableRow key={"4"}>
								<TableCell align="right">
									<b>Currently: </b>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
									{alerts?.find(alert => alert._id === stolenAlert)?.vehicles.find(alertvehicle => alertvehicle.vehicle._id === vehicle._id) ? 'Marked as Stolen' : 'Not Stolen'}
								</TableCell>
								<TableCell align="right" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiDominoMask} size={1} />}
										onClick={handleAddStolen}
									>
										Stolen
									</Button>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiDominoMask} size={1} />}
										onClick={handleRemoveStolen}
									>
										Not Stolen
									</Button>
								</TableCell>
							</TableRow>
						}
						{checkRole(profile, ['VehicleGetRecord'], false) && ['FMC130', 'FMU125', 'FMC001', 'FMC003', "FMC150", "FMM130", "FMU125"].includes(vehicle.tracker.model) &&
							<TableRow key={"5"}>
								<TableCell align="right">
									<b>Get Record: </b>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
								</TableCell>
								<TableCell align="right" style={{ paddingLeft: 0 }}>
									<Button
										variant="contained"
										color="primary"
										size="small"
										className={classes.button}
										startIcon={<Icon path={mdiCrosshairsGps} size={1} />}
										onClick={handleGetRecordCommand}
									>
										Get Record
									</Button>
								</TableCell>
								<TableCell align="left" style={{ paddingLeft: 0 }}>
								</TableCell>
							</TableRow>
						}
					</TableHead>
				</Table>
			</TableContainer>
		</div>
	);
}
